import AdaptiveDatePicker from "app/components/AdaptiveDatePicker";
import { dropdownTriggerClassname } from "app/components/Dropdown";
import TimeIcon from "app/components/Icons/TimeIcon";
import CustomTooltip from "app/components/Tooltip";
import clsx from "clsx";
import { format } from "date-fns";
import React from "react";
import { toZonedTime } from "date-fns-tz";

interface Props {
  value: string;
  onUpdate: (date: string) => void;
}

const DueDateSelection: React.FC<Props> = ({ value, onUpdate }) => {
  const parsedDate = value ? new Date(value) : null;
  const handleChange = (val: Date | null) => {
    if (val) {
      onUpdate(val.toISOString());
    }
  };
  return (
    <div className="relative w-full ">
      <AdaptiveDatePicker
        isDisablePastDate
        value={parsedDate}
        onChange={(v) => {
          handleChange(v);
        }}
        trigger={
          <button
            className={clsx(
              "flex items-center justify-between w-full p-[6px]",
              dropdownTriggerClassname,
            )}
          >
            <CustomTooltip
              text="Set due date"
              className="flex items-center "
              position="left"
            >
              <div className="flex items-center gap-1 w-full">
                <TimeIcon size={18} color="#79808A" />
                <span
                  className={`text-xs font-normal text-nowrap overflow-hidden text-ellipsis `}
                >
                  {parsedDate
                    ? format(toZonedTime(parsedDate, "UTC"), "dd MMM, yyyy")
                    : ""}
                </span>
              </div>
            </CustomTooltip>
          </button>
        }
      />
    </div>
  );
};

export default DueDateSelection;
